import './css/app.scss'

import {Header} from './js/layout'
import {Insights, Jobs} from './js/pages'
import {ArticlesPreview, JobsPreview, Testimonials, Advantages, Solicitation, Values, NewJobs} from './js/sections'
import {CookiesBar} from './js/ui'

const initScripts = {
  init: function () {
    Header()

    Insights()
    Jobs()

    ArticlesPreview()
    NewJobs()
    JobsPreview()
    Testimonials()
    Advantages()
    Solicitation()
    Values()

    CookiesBar()
  }

}
initScripts.init()

const popup = document.querySelector('.popup');
const popupButtons = document.querySelectorAll('[data-popup]');

Array.from(popupButtons).map(button => button.addEventListener('click', (e) => {
  popup.classList.toggle('popup_active');
}));
